export const DEFAULT_THINGS_TO_DO_SCHEMA_URL = 'https://heygirl.cutestperson.com/assets/public/schemas/DefaultThingsToDo_v1.3.0.json' as const;
export const DEFAULT_THINGS_TO_DO_COMPONENT_TYPE = 'DefaultThingsToDo' as const;
